import AuthService from '../AuthService'

const ActivateUuidApp = {}

const appElement = document.getElementById('activate-uuid-app')

if (appElement) {
  AuthService.redirectSignup()
}

export default ActivateUuidApp
